import { ILimitOrder } from "@perp/sdk-curie"
import { usePerpTransactionSender } from "sdk-react/perpetualProtocol/usePerpTransactionSender"

export function useCancelLimitOrder() {
    const cancelLimitOrder = usePerpTransactionSender(({ limitOrderBook }, args: ILimitOrder) => {
        return limitOrderBook.cancelLimitOrder(args)
    }, [])

    return {
        cancelLimitOrder,
    }
}
